module.exports = __webpack_public_path__ + "fonts/ff603d7e8732d0d4e79e6f8b1e84c20d.otf";